import { TSkillObject } from "../../../services/api/instances/skillsApi/types";
import i18n from "../../../services/i18n";
import { INIT_SKILL_VALUE } from "../constants";

const generateMetadataBlock = (meta: unknown) => {
  if (!meta || typeof meta !== "object") return "";
  const arr = Object.entries(meta);

  if (arr.length === 0) return "";

  let result = `**metadata**:\n`;
  for (const [key, value] of arr) {
    let stringValue = String(value);
    const lines = stringValue.split("\n");

    let formattedValue = lines[0];

    if (lines.length > 1) {
      formattedValue += `\n${lines.slice(1).join("\n")}`;
    }
    result += `- **${key}**: ${formattedValue}\n`;
  }

  return result;
};

export const generateSkillMd = (skill: TSkillObject | null | undefined) => {
  const data = skill ? skill : INIT_SKILL_VALUE.skill_object;
  const meta = data?.metadata && data.metadata;
  const yamlBlock = `---\n
**name**: ${data.name}\n
**description**: ${data.description}\n
${generateMetadataBlock(meta)}
---`;
  const markdownBody = `
## ${i18n.t("skills.instruction_field")}"${data.name}"

${data.instruction}
`;

  return `${yamlBlock}\n\n${markdownBody}`;
};
